import React, { useState } from 'react';
import { ParticlesProvider } from '@tsparticles/react';
import { loadStarsPreset } from '@tsparticles/preset-stars';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
// import FeaturedProject from './components/FeaturedProject'; // 2026-06-13 archived — removed from layout
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import ParticlesBackground from './components/ParticlesBackground';
import './App.css';

const engineInit = async (engine) => {
  await loadStarsPreset(engine);
};

function App() {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <ParticlesProvider init={engineInit}>
      <div className="App">
        <ParticlesBackground />
        <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
        <main>
          <Hero setActiveSection={setActiveSection} />
          {/* <FeaturedProject /> */}
          <Projects />
          <Skills />
          <Certifications />
          <Contact />
        </main>
      </div>
    </ParticlesProvider>
  );
}

export default App;
